// extracted by mini-css-extract-plugin
export default {"button":"gradientGrayButton_button__IeL+H"};